<div class="ra-filters">
    <div class="ra-filters__group">
        <span class="ra-filters__label" id="ra-grant-filter-type-label">Funder type</span>
        <agu-multi-select [Options]="Facets?.funderTypes ?? []" [Selected]="Selected('funderType')" AllLabel="All funder types" GroupLabel="Funder type" LabelledBy="ra-grant-filter-type-label" (SelectedChange)="OnArrayChange('funderType', $event)" />
    </div>

    <div class="ra-filters__group">
        <span class="ra-filters__label" id="ra-grant-filter-grantor-label">Funder / agency</span>
        <agu-multi-select [Options]="Facets?.grantors ?? []" [Selected]="Selected('grantor')" AllLabel="All funders" GroupLabel="Funder / agency" LabelledBy="ra-grant-filter-grantor-label" (SelectedChange)="OnArrayChange('grantor', $event)" />
    </div>

    <div class="ra-filters__group">
        <label class="ra-filters__label" for="ra-grant-filter-closing">Closing date</label>
        <agu-select Id="ra-grant-filter-closing" AriaLabel="Closing date" [Options]="ClosingDateSelect" [Value]="ClosingDateValue" (ValueChange)="OnClosingDateSelect($event)" />
    </div>

    <!-- More filters (P/grant-finder.html:1035-1054): the four rarer groups fold away; it opens by itself when any of them is set (:1596).
         "Career stage" (:1034) is not a ResearchGrantFilterInput field in this build, so the rail goes Funder type · Funder / agency · Closing date · fold. -->
    <agu-rail-fold Tone="grants" [FoldOpen]="FoldHasFilters">
        <div class="ra-filters__group">
            <label class="ra-filters__label" for="ra-grant-filter-award">Award amount</label>
            <agu-select Id="ra-grant-filter-award" AriaLabel="Award amount" [Options]="AwardSelect" [Value]="AwardValue" (ValueChange)="OnAwardSelect($event)" />
        </div>

        <div class="ra-filters__group">
            <span class="ra-filters__label" id="ra-grant-filter-elig-label">Eligible applicants</span>
            <agu-multi-select [Options]="EligibilityShortLabels" [Selected]="SelectedEligibilityShort" AllLabel="Any applicant type" GroupLabel="Eligible applicants" LabelledBy="ra-grant-filter-elig-label" (SelectedChange)="OnEligibilityChange($event)" />
        </div>

        <div class="ra-filters__group">
            <span class="ra-filters__label" id="ra-grant-filter-region-label">State / region</span>
            <agu-multi-select [Options]="Facets?.regions ?? []" [Selected]="Selected('region')" AllLabel="Anywhere / no restriction" GroupLabel="State / region" LabelledBy="ra-grant-filter-region-label" (SelectedChange)="OnArrayChange('region', $event)" />
        </div>

        <div class="ra-filters__group">
            <label class="ra-filters__label" for="ra-grant-filter-posted">Date posted</label>
            <agu-select Id="ra-grant-filter-posted" AriaLabel="Date posted" [Options]="DatePostedSelect" [Value]="DatePostedValue" (ValueChange)="OnDatePostedSelect($event)" />
        </div>
    </agu-rail-fold>

    <div class="ra-filters__group">
        <span class="ra-filters__label" id="ra-grant-filter-show-label">Show</span>
        <!-- MJSwitchComponent's accessible name comes from OnLabel/OffLabel content (see the prior version of this file's doc comment); each switch repeats its own name as both labels. -->
        <div class="ra-filters__switches" role="group" aria-labelledby="ra-grant-filter-show-label">
            <div class="ra-filters__switch-row">
                <mj-switch OnLabel="Recommended only" OffLabel="Recommended only" [ngModel]="RecommendedOnly" (ngModelChange)="RecommendedOnlyChange.emit($event)" />
            </div>
            <div class="ra-filters__switch-row">
                <mj-switch OnLabel="New only" OffLabel="New only" [ngModel]="ShowNewOnly" (ngModelChange)="ShowNewOnlyChange.emit($event)" />
            </div>
            <div class="ra-filters__switch-row">
                <mj-switch OnLabel="Saved only" OffLabel="Saved only" [ngModel]="ShowSavedOnly" (ngModelChange)="ShowSavedOnlyChange.emit($event)" />
            </div>
            <div class="ra-filters__switch-row">
                <mj-switch OnLabel="Include closed grants" OffLabel="Include closed grants" [ngModel]="IncludeClosed" (ngModelChange)="OnIncludeClosedChange($event)" />
            </div>
        </div>
    </div>
</div>
